export const fetchIDFacture = async () => {


    const token = localStorage.getItem('token'); 
    const apiUrl = process.env.REACT_APP_API_URL;

    
    try {
        const response = await fetch(`${apiUrl}/api/facturation/current-id`,{
            headers: { 'Authorization': `Bearer ${token}`},
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error('Failed to fetch id facture');
        }

        const data = await response.json();
        return data; 
    } catch (error) {
        console.error('Error fetching id facture:', error);
        throw error; 
    }
};